import { EmptyHeadline } from '../empty';

/**
 * A title used to describe an error state condition. Part of the multipart `Error` component. Composes `Box`.
 */
export const ErrorHeadline = EmptyHeadline;
ErrorHeadline.displayName = 'ErrorHeadline';
